import React from 'react';
import Text from 'components/Text';
import styled from 'styled-components';
var TextMaxLines = styled(Text).withConfig({
  displayName: "Description__TextMaxLines",
  componentId: "sc-1qhtzr9-0"
})(["", ";"], function (props) {
  return props.maxLines && "\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: ".concat(props.maxLines, ";\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t");
});
export default function Description(_ref) {
  var title = _ref.title,
    maxLines = _ref.maxLines,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "dt",
    overflow: "wrap",
    maxWidth: "100%"
  }, title), /*#__PURE__*/React.createElement(TextMaxLines, {
    as: "dd",
    overflow: "wrap",
    maxWidth: "100%",
    maxLines: maxLines
  }, children));
}